import UpdateIcon from "@mui/icons-material/Update";

import { LabelValue } from "../../components/LabelValue";
import { useProductTranslation } from "../../hooks/useProductTranslation";

export type ProductBestTimeToVisitMetaDataProps = {
    bestTimeToVisit: string;
};

export function ProductBestTimeToVisitMetaData({ bestTimeToVisit }: ProductBestTimeToVisitMetaDataProps) {
    const [t] = useProductTranslation();
    const label = t("label.bestTime");
    return (
        <LabelValue label={label} Icon={UpdateIcon}>
            {bestTimeToVisit}
        </LabelValue>
    );
}
